import Model from 'flarum/common/Model';
export default class ArenaCard extends Model {
  name() {
    return Model.attribute('name').call(this);
  }
  description() {
    return Model.attribute('description').call(this);
  }
  imageUrl() {
    return Model.attribute('imageUrl').call(this);
  }
  element() {
    return Model.attribute('element').call(this);
  }
  attack() {
    return Model.attribute('attack').call(this);
  }
  defense() {
    return Model.attribute('defense').call(this);
  }
  cost() {
    return Model.attribute('cost').call(this);
  }
  order() {
    return Model.attribute('order').call(this);
  }

  // Block 2 fields
  cardType() {
    return Model.attribute('cardType').call(this) ?? 'elemental';
  }
  bonusEffect() {
    return Model.attribute('bonusEffect').call(this);
  }
  bonusValue() {
    return Model.attribute('bonusValue').call(this);
  }
  isActive() {
    return Model.attribute('isActive').call(this) ?? true;
  }
  isPublic() {
    return Model.attribute('isPublic').call(this) ?? true;
  }
  isBonus() {
    return this.cardType() === 'bonus';
  }
}
flarum.reg.add('forumaker-arena', 'common/models/ArenaCard', ArenaCard);